export default __webpack_public_path__ + "static/media/logoWhite.4c902f6a.svg";